export const ADMIN_ROLE = 'admin'
export const CLIENT_ROLE = 'client'
export const RECRUITER_ROLE = 'recruiter'
export const GUEST_ROLE = 'decision_maker'

export const IS_ADMIN_KEY = 'isAdmin';
/** @deprecated use ADMIN_TOKEN_KEY in localStorage.ts */
export const ADMIN_TOKEN = 'admin_token';
